import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import {loaderDisable, loaderEnable} from "../../ui/loaderView";
import {ROUTES} from "../../../routes";
import {saveQuote} from "../../../api/server-api";
import WithPaymentSubmit from "./withPaymentSubmit";
import {getAnalyticsEcommerceValues} from "../../../analyticsEcommerceParams";
import {IS_DEALER_FLOW} from "../../../config";
import {postDealerShipToAddress} from "../../../api/cart-api";

export default (WrappedComponent) => {

  const WithCartCheckoutClick = (props) => {

    const {history, location, userIsLoggedIn, isMobile, fabricatorSettings, postDealerShipToAddress} = props;

    const isDeliveryPage = !!(location && location.pathname && location.pathname.includes(ROUTES.cartDelivery));

    return (
      <WithPaymentSubmit>
        {(paymentSubmit) => {

          const cartCheckoutClick = async () => {
            Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.cartCheckoutLogin);
            if (!userIsLoggedIn) {
              history.push(isMobile ? ROUTES.cartRegister : ROUTES.cartLogin);
              return;
            }
            if (fabricatorSettings.useShipping && !isDeliveryPage) {
              history.push(ROUTES.cartDelivery);
              return;
            }
            loaderEnable();
            const savedSuccess = await saveQuote({
              submit: true,
              fromCheckOutPage: true,
              showReceipt: false
            });
            if (savedSuccess) {
              document.kvConfig.jobId = savedSuccess.jobId;
            }
            if (savedSuccess && IS_DEALER_FLOW) {
              await postDealerShipToAddress();
            }
            const {currency, value, items, tax, shipping} = getAnalyticsEcommerceValues();
            if (fabricatorSettings.hasPaymentGateway) {
              const paymentResponse = await paymentSubmit();
              console.log("paymentResponse", paymentResponse);
              Analytics.sendEcommerceEvent("purchase", {currency, value, items,
                coupon: "", // "SUMMER_FUN" // we are not using that
                tax,
                shipping,
                transaction_id: paymentResponse && paymentResponse.transactionResponse && paymentResponse.transactionResponse.transId
                  ? paymentResponse.transactionResponse.transId : "NO_TRANSACTION_ID" ,
              });
              loaderDisable();
              if (!paymentResponse || !paymentResponse.transactionResponse || paymentResponse.transactionResponse.responseCode !== '1') {
                return false
              }
            } else {
              Analytics.sendEcommerceEvent("purchase", {currency, value, items,
                coupon: "", // "SUMMER_FUN" // we are not using that
                tax,
                shipping,
                transaction_id: "NO_PAYMENT_GATEWAY_SET",
              });
            }
            loaderDisable();
            if (savedSuccess) {
              history.push(ROUTES.cartSuccess);
            }
          }

          return (
            <WrappedComponent {...props} cartCheckoutClick={cartCheckoutClick}/>
          )
        }}
      </WithPaymentSubmit>
    )

  };

  const mapStateToProps = (store) => {
    const {isMobile} = store.serverState;
    const {userIsLoggedIn} = store.userState;
    const {settings} = store.fabricatorState;

    return {
      isMobile,
      userIsLoggedIn,
      fabricatorSettings: settings,
    };
  };

  const mapDispatchToProps = {
    postDealerShipToAddress,
  };

  return withRouter(
    connect(mapStateToProps, mapDispatchToProps)(WithCartCheckoutClick)
  )
}
